import { render, staticRenderFns } from "./IssueForm.vue?vue&type=template&id=4f9681c6&"
import script from "./IssueForm.vue?vue&type=script&lang=js&"
export * from "./IssueForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports